import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  form: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',

    '& > .MuiFormControl-root': {
      marginBottom: theme.spacing(2.5),
    },

    '& > .MuiButtonBase-root': {
      width: '100%',
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
}));
